module.exports = __webpack_public_path__ + "img/ep4-7.a19172be.png";